<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in">
      <v-flex>
        <v-card>
          <v-container fluid>
            <v-layout row wrap class="vertical-center-container">
              <!-- <v-flex xs12 class="pl-0 pb-0"> 
                <v-btn v-if="userAuthClass" :color="$store.state.global.pages.confirmedTrip.color" flat @click="openAddRctisDialog()">Create RCTIs</v-btn>
                <v-btn v-if="userAuthClass" :color="$store.state.global.pages.confirmedTrip.color" flat @click="openAddBillsDialog()">Create Bills</v-btn>
              </v-flex>-->

              <multi-trip-actions
                page="trips"
                v-if="$route.name == 'docket' && userAuthClass"
                :selectedCount="selectedCount"
              ></multi-trip-actions>

              <v-spacer></v-spacer>
              <v-flex xs12 sm2 md4 class="text-xs-right">
                <v-tooltip bottom v-if="selected.length > 0 && !selectedAll">
                  <v-btn
                    flat
                    color="grey"
                    icon
                    @click="selected = []; selectedAll = false"
                    slot="activator"
                  >
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  <span>Deselect All</span>
                </v-tooltip>
                <v-tooltip
                  bottom
                  v-if="this.$store.state.user.userAuthClass.rctiWrite || this.$store.state.user.userAuthClass.billingWrite"
                >
                  <v-menu
                    slot="activator"
                    bottom
                    left
                    transition="scale-transition"
                    :close-on-content-click="true"
                    v-model="toolsMenu"
                  >
                    <v-btn flat color="grey" icon slot="activator">
                      <v-icon>check_circle</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        @click="openAddRctisDialog()"
                        v-if="this.$store.state.user.userAuthClass.rctiWrite"
                      >
                        <v-list-tile-action>
                          <v-icon
                            :color="$store.state.global.pages.rcti.color"
                          >{{$store.state.global.pages.rcti.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Create RCTIs</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="openAddBillsDialog()"
                        v-if="this.$store.state.user.userAuthClass.billingWrite"
                      >
                        <v-list-tile-action>
                          <v-icon
                            :color="$store.state.global.pages.billing.color"
                          >{{$store.state.global.pages.billing.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Create Bills</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <span>Tools</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-menu
                    slot="activator"
                    bottom
                    left
                    transition="scale-transition"
                    max-height="600px"
                    origin="top right"
                    :close-on-content-click="false"
                    v-model="fieldChooserMenu"
                  >
                    <v-btn flat icon color="grey" slot="activator">
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                        <v-list-tile-action>
                          <v-checkbox
                            :color="$store.state.global.pages.docket.color"
                            v-model="defaultHeaders"
                            :label="header.text"
                            :value="header.value"
                          ></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <span>Add & Remove Columns</span>
                </v-tooltip>
              </v-flex>

              <!-- SELECT ALL TRIPS ALERT -->
              <v-alert
                v-if="selectedCount >= 10"
                :value="true"
                color="grey lighten-3"
                icon="notification_important"
                style="width: 100%; border-radius: 4px;"
                class="grey--text text--darken-2 py-1"
              >
                <div class="flex-container-center">
                  <span>{{selectedCount}} items are selected.</span>
                  <v-btn
                    v-if="selectedAll"
                    @click="selected = []; selectedAll = false;"
                    flat
                    color="grey"
                  >Unselect all {{$vuetify.breakpoint.smAndUp ? `${selectedCount} items` : ''}}</v-btn>
                  <v-btn
                    v-else
                    @click="selectedAll = true"
                    flat
                    :color="$store.state.global.pages.docket.color"
                  >Select all {{$vuetify.breakpoint.smAndUp ? `${pagination.totalItems} items` : ''}}</v-btn>
                </div>
              </v-alert>
            </v-layout>
          </v-container>

          <v-data-table
            :items="trips"
            :headers="headers"
            :pagination.sync="pagination"
            :rows-per-page-items="pagination.rowsPerPageItems"
            :total-items="pagination.totalItems"
            v-model="selected"
            select-all
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <div class="text-xs-center grey--text subheading">No trips for the selected criteria.</div>
            </template>

            <template slot="items" slot-scope="props">
              <trip-row
                :trip="props.item"
                :value="props.selected"
                :headers="headers"
                @input="toggleSelected"
                @showTripFromDocket="showTripFromDocket"
                :key="props.item.id+props.item.docket.updatedAt"
                :ref="props.item.id"
              ></trip-row>
            </template>
          </v-data-table>
          <first-last-page @page="(obj) => pagination = obj" :pagination="pagination"></first-last-page>
          <!-- DISPLAY TRIP TOTALS -->
          <!-- DISPLAY TRIP TOTALS -->
          <v-container fluid>
            <v-layout row wrap v-if="!!trips.length" class="grey--text">
              <v-flex xs12 sm6 md5 lg3>
                <div>
                  <div
                    class="text-xs-left flex-container-space-between mb-2"
                    v-if="!!totals.hoursTotal"
                  >
                    <div>
                      <span class="text-xs-left grey--text text--darken-1 body-2">Hours:</span>
                    </div>
                    <div class="ml-2">
                      <span class="text-xs-right">{{addCommas(totals.hoursTotal.toFixed(1))}} hrs</span>
                    </div>
                  </div>
                  <div
                    class="text-xs-left flex-container-space-between mb-2"
                    v-if="!!totals.siteWeightTotal"
                  >
                    <div>
                      <span
                        class="text-xs-left grey--text text--darken-1 body-2"
                      >Tip / Weighbridge Weight:</span>
                    </div>
                    <div class="ml-2">
                      <span
                        class="text-xs-right"
                      >{{addCommas(totals.siteWeightTotal.toFixed(0))}} tonne</span>
                    </div>
                  </div>
                  <div
                    class="text-xs-left flex-container-space-between mb-2"
                    v-if="!!totals.tipWeightTotal"
                  >
                    <div>
                      <span class="text-xs-left grey--text text--darken-1 body-2">Site / LR Weight:</span>
                    </div>
                    <div class="ml-2">
                      <span
                        class="text-xs-right"
                      >{{addCommas(totals.tipWeightTotal.toFixed(0))}} tonne</span>
                    </div>
                  </div>
                  <div
                    class="text-xs-left flex-container-space-between"
                    v-if="!!totals.scaleWeightTotal"
                  >
                    <div>
                      <span
                        class="text-xs-left grey--text text--darken-1 body-2"
                      >Truck / Scale Weight:</span>
                    </div>
                    <div class="ml-2">
                      <span
                        class="text-xs-right"
                      >{{addCommas(totals.scaleWeightTotal.toFixed(0))}} tonne</span>
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm4 md3>
                <div>
                  <div
                    class="text-xs-right flex-container-space-between mb-2"
                    v-if="!!totals.costTotal && !!userShowCost"
                  >
                    <div>
                      <span class="text-xs-left grey--text text--darken-1 body-2">Cost:</span>
                    </div>
                    <div class="ml-2">
                      <span class="text-xs-right">${{addCommas(parseFloat(totals.costTotal).toFixed(2))}}</span>
                    </div>
                  </div>
                  <div
                    class="text-xs-right flex-container-space-between"
                    v-if="!!totals.sellTotal && !!userShowSell"
                  >
                    <div>
                      <span class="text-xs-left grey--text text--darken-1 body-2">Sell:</span>
                    </div>
                    <div class="ml-2">
                      <span class="text-xs-right">${{addCommas(parseFloat(totals.sellTotal).toFixed(2))}}</span>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </transition>

    <!-- ADD RCTIS DIALOG -->
    <v-dialog v-model="addRctisDialog" lazy max-width="700px">
      <add-rctis :dialogOpen="addRctisDialog" @close="addRctisDialog = false"></add-rctis>
    </v-dialog>
    <!-- ADD BILLS DIALOG -->
    <v-dialog v-model="addBillsDialog" lazy max-width="700px">
      <add-bills :dialogOpen="addBillsDialog" @close="addBillsDialog = false"></add-bills>
    </v-dialog>
  </layout-no-padding>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'
import TripRow from '@/components/trips/tripRow'
import MultiTripActions from '@/components/trips/actions/multiTripActions'
import CalculateTotal from '@/services/mixins/calculateTotal'
import TripViewMixin from '@/components/trips/tripViewMixin'
import HeaderFilters from '@/services/mixins/headerFilters'
import BuildTripQuery from '@/services/mixins/buildTripQuery'
import AddRctis from '@/components/trips/actions/addRctis'
import AddBills from '@/components/trips/actions/addBills'
import virtualList from 'vue-virtual-scroll-list'
import { debounce } from 'lodash'
import BillingPeriods from '@/services/mixins/billingPeriods'

export default {
  mixins: [
    HeaderFilters,
    TripViewMixin,
    CalculateTotal,
    BuildTripQuery,
    BillingPeriods
  ],
  data() {
    return {
      color: 'blue',
      searchTerm: '',
      loading: false,
      fieldChooserMenu: false,
      toolsMenu: false,
      addRctisDialog: false,
      addBillsDialog: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        rowsPerPageItems: [10, 20, 40, 50]
      },
      totals: null
    }
  },
  methods: {
    showTripFromDocket(tripId) {
      this.$refs[tripId].detailDialog = true
    },
    //ADDS OR REMOVES OBJECTS FROM THE SELECTED ARRAY, DEPENDING ON WHETHER TRUE OR FALSE WAS EMMITED FROM TRIPROW COMPONENT
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object)
      } else {
        var index = this.selected.indexOf(val.object)
        this.selected.splice(index, 1)
      }
    },
    getTrips(keepPage) {
      if (!keepPage) this.pagination.page = 1
      //BUILD QUERY FROM MIXIN
      var payload = this.buildQuery()
      payload.pagination = this.pagination
      // if (this.$route.name == 'confirmedTrip') {
      //     payload.type = 'rctis';
      //     payload.showClosed = false;
      //     this.getConfirmedTrips(payload)
      // } else if (this.$route.name == 'confirmedTripBilling') {
      //     //this.getConfirmedTripsBilling()
      //     payload.type = 'billing';
      //     payload.showClosed = false;
      //     this.getConfirmedTrips(payload)
      // } else {
      //     this.getUnconfirmedTrips(payload)
      // }
      this.getUnconfirmedTrips(payload)
    },
    getUnconfirmedTrips(payload) {
      this.loading = true
      DocketService.getUnconfirmedTrips(payload)
        .then(result => {
          //console.log(result);
          this.trips = result.data.result

          this.pagination.totalItems = result.data.count
          this.totals = result.data.totals
          this.loading = false
        })
        .catch(err => {
          this.snackError()
          console.log(err)
          this.loading = false
        })
    },

    openAddRctisDialog() {
      if (
        !this.projectId ||
        !this.billingPeriod ||
        !this.openBillingPeriods.find(
          billingPeriod => billingPeriod === this.billingPeriod
        )
      ) {
        this.snack({
          color: 'yellow',
          text: 'You must select an open billing period and a project!'
        })
        return
      } else {
        this.addRctisDialog = true
      }
    },
    openAddBillsDialog() {
      if (
        !this.projectId ||
        !this.billingPeriod ||
        !this.openBillingPeriods.find(
          billingPeriod => billingPeriod === this.billingPeriod
        )
      ) {
        this.snack({
          color: 'yellow',
          text: 'You must select an open billing period and a project!'
        })
        return
      } else {
        this.addBillsDialog = true
      }
    }
  },
  computed: {
    trips: Store.getSet({ store: 'trips', prop: 'trips' }),
    filterBy: Store.getSet({ store: 'trips', prop: 'filterBy' }),
    filterCol: Store.getSet({ store: 'trips', prop: 'filterCol' }),
    filterBy2: Store.getSet({ store: 'trips', prop: 'filterBy2' }),
    filterCol2: Store.getSet({ store: 'trips', prop: 'filterCol2' }),
    dates: Store.getSet({ store: 'trips', prop: 'dates' }),
    billingStatus: Store.getSet({ store: 'shared', prop: 'billingStatus' }),
    selected: Store.getSet({ store: 'trips', prop: 'selected' }),
    selectedAll: Store.getSet({ store: 'trips', prop: 'selectedAll' }),
    selectedCount() {
      if (this.selectedAll) {
        return this.pagination.totalItems
      } else {
        return this.selected.length
      }
    },
    showClosed: Store.getSet({ store: 'shared', prop: 'showClosed' }),
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    dateRangeStart: Store.getSet({ store: 'shared', prop: 'dateRangeStart' }),
    dateRangeEnd: Store.getSet({ store: 'shared', prop: 'dateRangeEnd' }),
    fetchTrips: Store.getSet({ store: 'trips', prop: 'fetchTrips' })
  },
  mounted() {
    this.getTrips()
  },
  beforeDestroy() {
    this.trips = []
    this.selected = []
  },
  components: {
    TripRow,
    MultiTripActions,
    AddRctis,
    AddBills,
    virtualList
  },
  watch: {
    //TRIGGER REQUERIES OF DATA WHEN FILTERS CHANGE
    billingPeriod(val) {
      this.getTrips()
    },
    billingStatus(val) {
      this.getTrips()
    },
    showClosed(val) {
      this.getTrips()
    },
    projectId(val) {
      this.getTrips()
    },
    siteId(val) {
      this.getTrips()
    },
    selectedUserId(val) {
      this.getTrips()
    },
    pagination(val) {
      //console.log('PAGINATION CHANGED');

      this.getTrips(true)
      this.$store.commit('trips/setState', { prop: 'pagination', value: val })
    },
    filterCol: debounce(function() {
      this.getTrips()
    }, 200),
    filterBy: debounce(function() {
      this.getTrips()
    }, 500),
    filterCol2: debounce(function() {
      this.getTrips()
    }, 200),
    filterBy2: debounce(function() {
      this.getTrips()
    }, 500),
    dateRangeStart(val) {
      this.getTrips()
    },
    dateRangeEnd(val) {
      this.getTrips()
    },
    fetchTrips(val) {
      if (val) {
        this.fetchTrips = false
        this.getTrips(true)
      }
    }
    // trips: debounce(function() {
    //     this.getTrips()
    // }, 200),
  }
}
</script>

<style>
</style>
